<template>
  <div class="event-preview">
    <router-link
      class="event-preview__link"
      :to="{
        name: 'EventPage',
        params: {
          link: eventData.link,
        },
      }"
    >
      <div class="event-preview__image">
        <el-avatar :size="50">
          <activity-image :activity="eventData.activityId" />
        </el-avatar>
      </div>

      <div class="event-preview__content">
        <div class="event-preview__heading">
          <div class="event-preview__title" v-if="eventData.name">
            {{ eventData.name }}
          </div>

          <span class="event-preview__date" v-if="eventData.startDate">
            {{ formatDate(eventData.startDate, SHORT_DATETIME_FORMAT) }}
          </span>
        </div>

        <div class="event-preview__description" v-if="eventData.details">
          {{ eventData.details }}
        </div>

        <div class="event-preview__location" v-if="eventData.location">
          <i class="el-icon-location-outline"></i>
          {{ eventData.location }}
        </div>
      </div>
    </router-link>

    <div class="event-preview__button" v-if="isActive">
      <el-button
        :type="buttonType || 'primary'"
        @click.stop="handleClickButton"
      >
        {{ buttonLabel }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ActivityImage from '@/components/common/ActivityImage.vue';
import { formatDate, SHORT_DATETIME_FORMAT } from '@/utils/index.js';

export default {
  name: 'EventPreview',
  props: {
    eventData: {
      type: Object,
      required: true,
    },
    buttonType: {
      type: String,
      required: false,
    },
    buttonLabel: {
      type: String,
      required: false,
    },
    buttonAction: {
      type: Function,
      required: false,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    ActivityImage
  },
  data() {
    return {
      SHORT_DATETIME_FORMAT,
    };
  },
  methods: {
    formatDate,
    handleClickButton() {
      const { buttonAction, eventData } = this;

      if (buttonAction) {
        buttonAction(eventData);
      }
    },
  },
};
</script>

<style lang="scss">
.event-preview {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--global-dimension-size-450);

  line-height: 1.6;

  &__link {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    color: var(--color-gray-900);
  }

  &__image {
    margin-right: var(--global-dimension-size-125);
  }
  &__content {
    flex-grow: 1;
  }
  &__heading {
    display: flex;
    flex-flow: row nowrap;
    align-items: baseline;
    margin-bottom: var(--global-dimension-size-125);
  }
  &__title {
    font-weight: 500;
    font-size: var(--font-size-300);
    margin-right: var(--global-dimension-size-150);
  }
  &__date {
    font-size: var(--font-size-200);
  }
  &__description {
    margin-bottom: var(--global-dimension-size-100);
    font-size: var(--font-size-200);
  }
  &__location {
    font-size: var(--font-size-200);
    color: var(--color-gray-700);
  }
  &__button {
    margin-left: var(--global-dimension-size-350);
  }
}
</style>
